import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";

export const Container = styled.div``;

export const StyledBaseLink = styled(BaseLink)`
  display: block;
`;
